// extracted by mini-css-extract-plugin
export default {"badge":"badge_badge__Pd-mq","right":"badge_right__xs4Nb","margin":"badge_margin__DhP8T"};